export const offersEL = {
    shippingTitle : "ΔΩΡΕΑΝ ΜΕΤΑΦΟΡΙΚΑ",
    shippingText1 : "Με αγορές άνω των ",
    shippingText2 : "€ δωρεάν τα μεταφορικά!",
    cashTitle : "ΑΝΤΙΚΑΤΑΒΟΛΗ",
    cashText : "Δωρεάν αντικαταβολή για πληρωμή με μετρητά κατα την παράδοση!" ,
    topSellers : "Δημοφιλή" 
}